import styled from 'styled-components'

const ModalView = styled.div`
  display: flex;
  flex-direction: column;
  width: 280px;
  background-color: #eceff1;
  border-radius: 5px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
  padding: 10px;
`

export default ModalView
